import React from 'react'

import { Grid, useTheme } from '@mui/material'
import Container from '@mui/material/Container'
import Link from '@/components/Common/Link'
import SETTINGS from '@/src/settings'
import Typography from '@mui/material/Typography'
import LOCAL_STORAGE from '@/src/localstorage'
import cookie from 'js-cookie'

const Maintenance: React.FC = () => {
  const theme = useTheme()
  cookie.remove(LOCAL_STORAGE.name_cookie_token)

  return (
    <Container maxWidth={'lg'}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            <div>
              <div className="text-[22px] font-bold">Pharmedistore</div>
              <div className="text-[22px] font-bold" style={{ color: theme.palette.primary.main }}>
                est temporairement en maintenance, nous revenons très vite
              </div>
              <br />
              <div>
                {}
                En attendant, vous pouvez nous laisser vos coordonnées pour qu'on vous recontacte
                rapidement! Vous pouvez aussi nous ecrire à{' '}
                <Link
                  target="_blank"
                  href={`mailto:${SETTINGS.contact.mail}`}
                  useClassicLink
                  prefetch={false}
                >
                  <span className="font-bold" style={{ color: theme.palette.primary.main }}>{SETTINGS.contact.mail}</span>
                </Link>
                .<br />
                Nous revenons rapidement.
              </div>
              <br />

              <Typography variant={'h1'} paragraph align={'center'}>
                <br />
                Contactez nous au {SETTINGS.contact.phone_pharmedistore}
              </Typography>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <img src={'/images/maintenance_transfert.png'} alt={'Maintenance'} width={'100%'} />
        </Grid>
      </Grid>
    </Container>
  )
}

export default Maintenance
